import Styles from './inputs.module.scss';
import { Controller } from 'react-hook-form';

const CheckboxInput = ({ name, label, register, control, validationSchema, style, className }) => {
    if (control) {
        return (
            <div className={Styles.checkboxInput}>
                <Controller
                    name={name}
                    control={control}
                    rules={validationSchema}
                    render={({ field: { value, onChange, ref } }) => (
                        <div className={`relative text-left flex items-center ${className ?? ''}`} style={style}>
                            <input
                                className="inputField"
                                id={name}
                                type="checkbox"
                                ref={ref}
                                checked={Boolean(value)}
                                onChange={(e) => onChange(e.target.checked)}
                            />
                            <label htmlFor={name} className="inline pl-2 text-left text-primary-grey text-[13px] font-semibold">
                                {label}
                            </label>
                        </div>
                    )}
                />
            </div>
        );
    }

    return (
        <div className={Styles.checkboxInput}>
            <div className={`relative text-left flex items-center ${className ?? ''}`} style={style}>
                <input
                    className="inputField"
                    id={name}
                    name={name}
                    type="checkbox"
                    {...register(name, validationSchema)}
                />
                <label htmlFor={name} className="inline pl-2 text-left text-primary-grey text-[13px] font-semibold">
                    {label}
                </label>
            </div>
        </div>
    );
};

export { CheckboxInput };
